<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-house"></i>
          ຄິດໄລ່ຍອດລູກຄ້າເຊັນສັນຍາ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>

    </div>
    <div class="box">
      <div class="columns is-multiline is-mobile is-align-items-flex-end">
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <label class="label">ຄົ້ນຫາ:</label>
            <div class="control">
              <input
                  class="input"
                  placeholder="ຄົ້ນຫາ..."
                  type="text" name="name"
                  v-model="searchItem"
                  @keyup.enter="FetchData()"
              >
            </div>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <label class="label">ຈາກວັນທີ:</label>
            <div class="control">
              <date-picker
                  format="DD/MM/YYYY"
                  value-type="YYYY-MM-DD"
                  type="date"
                  v-model="start_date"
                  :disabled-date="disabledAfterToday"
                  :clearable="false"
                  name="start_date"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <label class="label">ຫາວັນທີ:</label>
            <div class="control">
              <date-picker
                  format="DD/MM/YYYY"
                  value-type="YYYY-MM-DD"
                  type="date"
                  v-model="end_date"
                  :disabled-date="disabledAfterToday"
                  :clearable="false"
                  name="end_date"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <div class="control">
              <vs-button
                  flat
                  @click="FetchData()"
                  class="form-btn-loading btn-align"
                  :loading="isLoading">
                <i class="fal fa-search"></i> ຄົ້ນຫາ
              </vs-button>
            </div>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <div class="control">
              <vs-button
                  flat
                  @click="printSummaryRegularCustomer()"
                  class="form-btn-loading btn-align"
                  :loading="loading">
                <i class="fal fa-file-export"></i> export excel
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ລະຫັດ</vs-th>
            <vs-th>ຊື່</vs-th>
            <vs-th>ເບີໂທ</vs-th>
            <vs-th>ຕົ້ນທາງ</vs-th>
            <vs-th>ຝາກບິນປາຍທາງ</vs-th>
            <vs-th>ລວມ</vs-th>
            <vs-th>ຝາກບິນປາຍທາງແລ້ວສຳເລັດ</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="customer"
              v-for="(customer, index) in $vs.getPage(customers, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ customer.customer_id }}</vs-td>
            <vs-td>{{ customer.name }}</vs-td>
            <vs-td>{{ customer.tel }}</vs-td>
            <vs-td><span class="qty">{{ FormatPrice(customer.originQty) }} ບິນ</span><br><span class="price">{{ FormatPrice(customer.originFreight) }} ກີບ</span></vs-td>
            <vs-td><span class="qty">{{ FormatPrice(customer.destinationCreatedQty) }} ບິນ</span><br><span class="price">{{ FormatPrice(customer.destinationCreatedFreight) }} ກີບ</span></vs-td>
            <vs-td><span class="qty">{{ FormatPrice(customer.totalCreatedQty) }} ບິນ</span><br><span class="price">{{ FormatPrice(customer.totalCreatedQtyFreight) }} ກີບ</span></vs-td>
            <vs-td><span class="qty">{{ FormatPrice(customer.destinationQty) }} ບິນ</span><br><span class="price">{{ FormatPrice(customer.destinationFreight) }} ກີບ</span></vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
    <CustomerExcelTemplate v-show="false" ref="ExportExcel"/>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import * as helper from "@/Helpers/GetValue";
import CustomerExcelTemplate from "@coms/printing/CustomerExcelTemplate";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    Loading,
    pagination,
    CustomerExcelTemplate,
    DatePicker
  },

  data: () => ({
    page: 1,
    max: 10,
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    loading: false,
    customer: '',
    customers: [],
    searchItem: "",
    oldVal: "",
    // Pagination
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {},
  }),
  created() {
    this.FetchData()
  },
  watch: {},
  methods: {
    FilterByShipmentNumber() {
      helper.GetOldValueOnInput(this);
    },
    printSummaryRegularCustomer() {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post('/marketing/print/summary/regular/shipment', {
        start_date: this.start_date,
        end_date: this.end_date,
        search: this.searchItem,
        print: 'yes',
      }, {responseType: 'blob'}).then((res) => {
        const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
        const fileLink = document.createElement('a');
        fileLink.href = fileUrl;
        if (this.start_date === this.end_date) {
          fileLink.setAttribute('download', 'ຄິດໄລ່ຍອດລູກຄ້າເຊັນສັນຍາວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + '.xlsx');
        } else {
          fileLink.setAttribute('download', 'ຄິດໄລ່ຍອດລູກຄ້າເຊັນສັນຍາວັນທີ ' + moment(this.start_date).format('DD-MM-YYYY') + 'ຫາ' + moment(this.end_date).format('DD-MM-YYYY') + '.xlsx');
        }
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        this.loading = false;
        loading.close()
      }).catch(() => {
        this.loading = false;
        loading.close()
      });
    },

    FormatPrice(price) {
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    disableDateCustomer(date) {
      const fixDay = moment('2021-08-01 00:00:00');
      return date < fixDay;
    },
    FetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        setTimeout(() => {
          this.customers = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
          this.oldVal = ''
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('/marketing/summary/regular/shipment', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
          search: this.searchItem,
          print: 'no',
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
    FilterBySearch() {
      helper.GetOldValueOnInput(this);
    },
    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
  overflow-x: auto;
}

.btn-align {
  height: 38px !important;
  min-height: 38px !important;
  margin-bottom: 4px;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: normal !important;
  width: 1px !important;
}

.qty {
  color: #2563eb;
  font-weight: 600;
}

.price {
  color: #16a34a;
  font-weight: 600;
}

</style>
